import styled from "styled-components";

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export default ItemWrapper